var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('menu-bar-item',{attrs:{"label":_vm.$t('dataset')}},[_c('ModuleOutlet',{attrs:{"module":"sspData","type":"datasetMenu"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }